'use client';

import { MenuItem } from '@mui/material';
import Link from 'next/link';
import { useParams } from 'next/navigation';

const OPTION_LABEL = 'Change Password';

const ChangePasswordOption: React.FC<{ closeMenu?: () => void }> = ({ closeMenu }) => {
  const params = useParams();
  return (
    <MenuItem onClick={closeMenu} component={Link} href={`/${params.subdomain}/change-password`}>
      <span>{OPTION_LABEL}</span>
    </MenuItem>
  );
};

export default ChangePasswordOption;
